import { union } from "lodash";

import type { IShoppingCartPosition } from "@/shop/types/shopping/cart";

export function mergeListItem(collection: IShoppingCartPosition[], additionalItem: IShoppingCartPosition): void {
  const listItem = collection.find((it) => {
    return it.id === additionalItem.id;
  });

  if (listItem) {
    // increase quantity
    listItem.qty = additionalItem.qty + listItem.qty;

    // update item attributes

    if (additionalItem.label != null) {
      listItem.label = additionalItem.label;
    }

    if (additionalItem.material != null) {
      listItem.material = additionalItem.material;
    }

    if (additionalItem.dimensions != null) {
      listItem.dimensions = additionalItem.dimensions;
    }

    if (additionalItem.qtyUnit != null) {
      listItem.qtyUnit = additionalItem.qtyUnit;
    }

    if (additionalItem.qtyUnitId != null) {
      listItem.qtyUnitId = additionalItem.qtyUnitId;
    }

    // merge array type data
    listItem.numbers = union(listItem.numbers, additionalItem.numbers);
    listItem.machines = union(listItem.machines, additionalItem.machines);
    listItem.orderIds = union(listItem.orderIds, additionalItem.orderIds);
    listItem.sdIds = union(listItem.sdIds, additionalItem.sdIds);
  } else {
    additionalItem.enabled = true;
    collection.push(additionalItem);
  }
}
